import { Component, ElementRef, TemplateRef, Input, ViewChild, ChangeDetectorRef, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../app.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { qmsService } from '../qms/qms.service';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from '../message.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { EditorComponent } from '../editor/editor.component';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EChartsOption } from 'echarts';
export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-one-qms-more-admin-report-details',
  templateUrl: './one-qms-more-admin-report-details.component.html',
  styleUrls: ['./one-qms-more-admin-report-details.component.scss']
})
export class OneQmsMoreAdminReportDetailsComponent implements OnInit {
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  reportName: any;
  isSaveReport: boolean = false;
  isProcessing: any;
  dynamicGridName: any;
  dynamicGridViewName: any;
  tableReportUserLoginFailedDataList: any = [];
  tableReportUserPasswordChangesDataList: any
  getOneQmsSwitchUserLogVw: any
  tableReportUserActiveUserDataList: any
  tableReportUserActivityMappingDataList: any
  tableReportUserRmDataList: any
  typeAdminReport: any;
  moduleListDropdown: any = [];
  createModuleValue: any = [];
  searchByModule: any = [];
  selectedModuleDisplayExp: any;
  selectedModuleValueExp: any;
  ownersListDropdown: any = [];
  searchByOwner: any = [];
  selectedGroupValue: any = null;
  designationSearchText: string = '';
  departmentSearchText: string = '';
  categorySearchText: string = '';
  languageSearchText: string = '';
  groupValueDropdown: any = [];
  groupValueDropdownTms: any = [];
  groupValueDropdownDms: any = [];
  showNoRecordFoundimg: boolean = false;
  groupSearchText: string = '';
  reportSearchText: string = '';
  moduleSearchText: string = '';
  pdfDetailSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  groupdataList: any = [];
  groupdataListTms: any = [];
  groupdataListDms: any = [];
  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;
  reportModuleValue: any = '';
  userActiveColumnIndex: number;
  managerName: string;
  managerId: any;
  showNoRecordFoundLoginFailed: boolean = false;
  showNoRecordFounduserPassword: boolean = false;
  showNoRecordFoundConcurrent: boolean = false;
  showNoRecordFoundUserVsRm: boolean = false;
  showNoRecordFoundUserVsActivity: boolean = false;
  showNoRecordFoundSwitchUserLog: boolean = false;
  loadBread: boolean = true;
  showTable: boolean = false;
  selectedGroupValueDynamicGridInput: any;
  reportModuleValueDynamicGridInput: any;
  getSelectedTrainingIdDynamicGridInput: any;
  selectedFolderId: any;

  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  selectedDesignationValue: any = [];
  selectedDepartmentValue: any = [];

  searchManagerParentCheckBox: boolean = false;
  searchManagerChildCheckBoxs: boolean = false;
  searchManagerChildCheckBox: boolean = false;
  searchManagerChildCheckBoxsMenu: boolean = false;

  getSelectedUserId: any;
  getSelectedUserName: string;
  privvalue: any;
  operationFlag: any
  oneQmsUsersFieldData: any = {};

  searchUserParentCheckBox: boolean = false;
  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByemailAddress: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  dropDownDataForModule: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];
  popupDataTitle: PopupData = {
    title: ''
  };

  htmlContent: any;
  snackbarRef: any;
  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  tmsUserTrainingsRepVwDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  selectedOption: string = 'user';
  timeRangeToggle: boolean = false;
  selectedCustomRange: string = '';
  startDate: string | null = null;
  endDate: string | null = null;

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  pagedItems: any[];
  pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  pagedItems4: any[];
  pagedItems5: any[];
  error = '';
  // specificIntervalVal: boolean = false;
  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;
  constructor(public dialog: MatDialog, public appService: AppService, public router: Router, public snackBar: MatSnackBar, public cdr: ChangeDetectorRef,
    public elem: ElementRef, public qmsservice: qmsService, public paginationService: PaginationService, public message: messageService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute) {
    this.message.breadcrumbData.thirdLevel = this.qmsservice.adminReportFor;
    const now = new Date();
    appService.isProcessingRep = false;
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

    // Initialize timeListDropdown to avoid undefined errors
    this.timeListDropdown = [];
  }

  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  showSpecificInterval: boolean = false;
  timeRangeToggleFun(e: any) {
    if (e.checked) {
      this.timeRangeToggle = true;
      this.showSpecificInterval = true;
      this.resetFunctions();
    } else {
      this.timeRangeToggle = false;
      this.showSpecificInterval = false;
      this.resetFunctions();
    }
  }
  dateCustomClasses: DatepickerDateCustomClasses[];
  fromDate: any;
  toDate: any;
  maxDate: Date = new Date();
  dateFormat: any = this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }
  showErrors: boolean = false;
  onRadioChange(): void {
    this.resetFunctions();
  }


  genReport() {

    let data = {
      wherVal: this.managerId
    }
    if (this.qmsservice.adminReportFor == 'User vs RM') {

      if (this.managerName) {

        forkJoin([
          this.appService.getOneQmsUserRMUserRep(data)
        ]).subscribe(([dataList]) => {

          this.isProcessing = true;
          this.tableReportUserActiveUserDataList = dataList;

          this.calculateTotalPages =
            this.collectionSize / this.perPage;

          this.pager.totalPages = undefined;

          this.collectionSize =
            this.tableReportUserActiveUserDataList.length;

          this.totalPages = Math.ceil(
            this.tableReportUserActiveUserDataList.length /
            this.itemsPerPage
          );

          this.setPage3(1, 0);

          this.showNoRecordFoundUserVsRm =
            this.tableReportUserActiveUserDataList.length === 0;

          this.isProcessing = false;
        });

      } else {

        const field = document.getElementById('userName') as HTMLInputElement;

        field.style.color = 'red';

        this.showNoRecordFoundUserVsRm = false;
      }
    } else if (this.qmsservice.adminReportFor == 'User vs Activity') {

      if (this.managerName) {

        forkJoin([
          this.appService.getOneQmsUserActiveUserMappingRep(data)
        ]).subscribe(([dataList]) => {

          this.isProcessing = true;

          this.tableReportUserActivityMappingDataList =
            dataList;

          this.calculateTotalPages =
            this.collectionSize / this.perPage;

          this.pager.totalPages = undefined;

          this.collectionSize =
            this.tableReportUserActivityMappingDataList.length;

          this.totalPages = Math.ceil(
            this.tableReportUserActivityMappingDataList.length /
            this.itemsPerPage
          );

          this.setPage4(1, 0);

          this.showNoRecordFoundUserVsActivity =
            this.tableReportUserActivityMappingDataList.length === 0;

          this.isProcessing = false;
        });

      } else {

        const field = document.getElementById(
          'userName2'
        ) as HTMLInputElement;

        field.style.color = 'red';
      }
    } else if (
      this.qmsservice.adminReportFor ===
      'User vs Functional Roles Privilege'
    ) {

      if (this.oneQmsUsersFieldData.managerName) {

        this.showTable = true;
        this.isProcessing = true;

        this.dynamicGridName = 'USER_PRIV';
        this.dynamicGridViewName =
          'ONEQMS_USER_PRIVS_REP_VW';

        this.typeAdminReport = 'userPriv';

        this.selectedGroupValueDynamicGridInput = null;
        this.reportModuleValueDynamicGridInput = null;
        this.getSelectedTrainingIdDynamicGridInput = null;

        this.getcallMethod();

      } else {

        const field = document.getElementById(
          'userName'
        ) as HTMLInputElement;

        field.style.color = 'red';
      }
    } else if (this.qmsservice.adminReportFor == 'Login Failed Attempts') {
      this.showErrors = false;
      if (this.selectedOption === 'user') {

        if (this.oneQmsUsersFieldData.managerName) {

          this.isProcessing = true;

          this.appService
            .getOneQmsUserLoginFailedAttemptsRep(
              this.oneQmsUsersFieldData.managerId.toString()
            )
            .subscribe((data) => {

              this.tableReportUserLoginFailedDataList = data;

              console.log(
                "data==1223",
                this.tableReportUserLoginFailedDataList
              );

              this.calculateTotalPages =
                this.collectionSize / this.perPage;

              this.pager.totalPages = undefined;

              this.typeAdminReport = "userPriv";

              this.collectionSize =
                this.tableReportUserLoginFailedDataList.length;

              this.totalPages = Math.ceil(
                this.tableReportUserLoginFailedDataList.length /
                this.itemsPerPage
              );

              this.setPage1(1, 0);

              this.showNoRecordFoundLoginFailed =
                this.tableReportUserLoginFailedDataList.length === 0;

              this.isProcessing = false;
            });

        } else {

          const field = document.getElementById(
            'userName1'
          ) as HTMLInputElement;

          field.style.color = 'red';

          this.showNoRecordFoundLoginFailed = false;
        }
      } else if (this.selectedOption === 'timeRange') {
        if (this.timeRangeToggle) {
          if (!this.fromDate || !this.toDate) {
            this.showErrors = true;
          } else if (new Date(this.fromDate) > new Date(this.toDate)) {
            alert('From Date cannot be greater than To Date.');

          } else {

            this.isProcessing = true;
            this.appService.getOneQmsUserLoginFailedAttemptsRepByTimeRange(null, this.fromDate ? this.fromDate.toString() : null, this.toDate ? this.toDate.toString() : null).subscribe((data) => {
              this.tableReportUserLoginFailedDataList = data;
              console.log("data==1223", this.tableReportUserLoginFailedDataList)
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.typeAdminReport = "userPriv";
              this.collectionSize = this.tableReportUserLoginFailedDataList.length;
              this.totalPages = Math.ceil(this.tableReportUserLoginFailedDataList.length / this.itemsPerPage);
              this.setPage1(1, 0);
              this.showNoRecordFoundLoginFailed = this.tableReportUserLoginFailedDataList.length === 0;
              this.isProcessing = false;
            })
          }
        } else if (this.timeRangeToggle === false) {

          if (this.selectedTimeRangeType) {

            this.isProcessing = true;

            this.appService
              .getOneQmsUserLoginFailedAttemptsRepByTimeRange(
                this.selectedTimeRangeType ?? null,
                null,
                null
              )
              .subscribe((data) => {

                this.tableReportUserLoginFailedDataList = data;

                console.log(
                  "data==1223",
                  this.tableReportUserLoginFailedDataList
                );

                this.calculateTotalPages =
                  this.collectionSize / this.perPage;

                this.pager.totalPages = undefined;

                this.typeAdminReport = "userPriv";

                this.collectionSize =
                  this.tableReportUserLoginFailedDataList.length;

                this.totalPages = Math.ceil(
                  this.tableReportUserLoginFailedDataList.length /
                  this.itemsPerPage
                );

                this.setPage1(1, 0);

                this.showNoRecordFoundLoginFailed =
                  this.tableReportUserLoginFailedDataList.length === 0;

                this.isProcessing = false;
              });

          } else {

            this.showErrors = true;
          }
        }
      }
    } else if (this.qmsservice.adminReportFor == 'User Login') {
      this.showErrors = false;
      if (this.selectedOption === 'user') {

        if (this.oneQmsUsersFieldData.managerName) {

          this.isProcessing = true;

          this.appService
            .getOneQmsUserLoginRep(
              this.oneQmsUsersFieldData.managerId.toString()
            )
            .subscribe((data: any) => {

              this.tableReportUserLoginFailedDataList = data;

              console.log(
                "data==1223",
                this.tableReportUserLoginFailedDataList
              );

              this.calculateTotalPages =
                this.collectionSize / this.perPage;

              this.pager.totalPages = undefined;

              this.typeAdminReport = "userPriv";

              this.collectionSize =
                this.tableReportUserLoginFailedDataList.length;

              this.totalPages = Math.ceil(
                this.tableReportUserLoginFailedDataList.length /
                this.itemsPerPage
              );

              this.setPage1(1, 0);

              this.showNoRecordFoundLoginFailed =
                this.tableReportUserLoginFailedDataList.length === 0;

              this.isProcessing = false;
            });

        } else {

          const field = document.getElementById(
            'userName1'
          ) as HTMLInputElement;

          field.style.color = 'red';

          this.showNoRecordFoundLoginFailed = false;
        }
      } else if (this.selectedOption === 'timeRange') {
        if (this.timeRangeToggle) {
          if (!this.fromDate || !this.toDate) {
            this.showErrors = true;
          } else if (new Date(this.fromDate) > new Date(this.toDate)) {
            alert('From Date cannot be greater than To Date.');

          } else {

            this.isProcessing = true;
            this.appService.getOneQmsUserLoginRepByTimeRange(null, this.fromDate ? this.fromDate.toString() : null, this.toDate ? this.toDate.toString() : null).subscribe((data) => {
              this.tableReportUserLoginFailedDataList = data;
              console.log("data==1223", this.tableReportUserLoginFailedDataList)
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.typeAdminReport = "userPriv";
              this.collectionSize = this.tableReportUserLoginFailedDataList.length;
              this.totalPages = Math.ceil(this.tableReportUserLoginFailedDataList.length / this.itemsPerPage);
              this.setPage1(1, 0);
              this.showNoRecordFoundLoginFailed = this.tableReportUserLoginFailedDataList.length === 0;
              this.isProcessing = false;
            })
          }
        } else if (this.timeRangeToggle === false) {

          if (this.selectedTimeRangeType) {

            this.isProcessing = true;

            this.appService
              .getOneQmsUserLoginRepByTimeRange(
                this.selectedTimeRangeType ?? null,
                null,
                null
              )
              .subscribe((data) => {

                this.tableReportUserLoginFailedDataList = data;

                console.log(
                  "data==1223",
                  this.tableReportUserLoginFailedDataList
                );

                this.calculateTotalPages =
                  this.collectionSize / this.perPage;

                this.pager.totalPages = undefined;

                this.typeAdminReport = "userPriv";

                this.collectionSize =
                  this.tableReportUserLoginFailedDataList.length;

                this.totalPages = Math.ceil(
                  this.tableReportUserLoginFailedDataList.length /
                  this.itemsPerPage
                );

                this.setPage1(1, 0);

                this.showNoRecordFoundLoginFailed =
                  this.tableReportUserLoginFailedDataList.length === 0;

                this.isProcessing = false;
              });

          } else {

            this.showErrors = true;
          }
        }
      }
    } else if (
      this.qmsservice.adminReportFor ==
      'User Password Changes'
    ) {

      if (this.oneQmsUsersFieldData.managerName) {

        this.isProcessing = true;

        this.appService
          .getOneQmsUserPasswordChangesRep(
            this.oneQmsUsersFieldData.managerId.toString()
          )
          .subscribe((data) => {

            this.tableReportUserPasswordChangesDataList =
              data;

            console.log(
              "data==1223",
              this.tableReportUserPasswordChangesDataList
            );

            this.calculateTotalPages =
              this.collectionSize / this.perPage;

            this.pager.totalPages = undefined;

            this.typeAdminReport = "userPriv";

            this.collectionSize =
              this.tableReportUserPasswordChangesDataList.length;

            this.totalPages = Math.ceil(
              this.tableReportUserPasswordChangesDataList.length /
              this.itemsPerPage
            );

            this.setPage2(1, 0);

            this.showNoRecordFounduserPassword =
              this.tableReportUserPasswordChangesDataList.length === 0;

            this.isProcessing = false;
          });

      } else {

        const field = document.getElementById(
          'userName5'
        ) as HTMLInputElement;

        field.style.color = 'red';

        this.showNoRecordFounduserPassword = false;
      }
    } else if (this.qmsservice.adminReportFor == 'QMS User Group') {

      if (this.selectedGroupValue) {

        this.isProcessing = true;
        this.showTable = true;

        this.dynamicGridName = "QMS_USER_GROUP";
        this.dynamicGridViewName = "QMS_USER_GROUP_REP_VW";

        this.typeAdminReport = "QMS";

        this.selectedGroupValueDynamicGridInput =
          this.selectedGroupValue ?? null;

        this.reportModuleValueDynamicGridInput =
          this.reportModuleValue ?? null;

        this.getSelectedTrainingIdDynamicGridInput = null;

        this.selectedFolderId = null;

        this.getcallMethod();

        this.isProcessing = false;

      } else {

        const field = document.getElementById(
          'groupNameAlert'
        ) as HTMLInputElement;

        field.style.color = 'red';
      }
    } else if (this.qmsservice.adminReportFor == 'DMS User Group') {

      if (this.selectedGroupValue) {

        this.isProcessing = true;
        this.showTable = true;

        this.dynamicGridName = "DMS_USER_GROUP";
        this.dynamicGridViewName = "DMS_USER_GROUP_REP_VW";
        this.typeAdminReport = "DMS";

        this.selectedGroupValueDynamicGridInput =
          this.selectedGroupValue ?? null;

        this.reportModuleValueDynamicGridInput = null;
        this.getSelectedTrainingIdDynamicGridInput = null;

        this.selectedFolderId =
          this.selectedFolderForCreateDoc.folderId;

        this.getcallMethod();

        this.isProcessing = false;

      } else {

        const field = document.getElementById(
          'groupNameAlert1'
        ) as HTMLInputElement;

        field.style.color = 'red';
      }
    } else if (this.qmsservice.adminReportFor == 'TMS User Group') {

      if (this.selectedGroupValue) {

        this.isProcessing = true;
        this.showTable = true;

        this.dynamicGridName = "TMS_USER_GROUP";
        this.dynamicGridViewName = "TMS_USER_GROUP_REP_VW";
        this.typeAdminReport = "TMS";

        this.selectedGroupValueDynamicGridInput =
          this.selectedGroupValue ?? null;

        this.reportModuleValueDynamicGridInput = null;

        this.getSelectedTrainingIdDynamicGridInput =
          this.getSelectedTrainingId;

        this.selectedFolderId = null;

        this.getcallMethod();

        this.isProcessing = false;

      } else {

        const field = document.getElementById(
          'groupNameAlert2'
        ) as HTMLInputElement;

        field.style.color = 'red';
      }
    } else if (this.qmsservice.adminReportFor == 'Switch User Log') {

      this.showErrors = true;

      const isModuleTypeRequired =
        this.selectedReportType === 'qualityIssue' ||
        this.selectedReportType === 'training';

      if (
        !this.selectedReportType ||
        (isModuleTypeRequired && !this.selectedModuleType)
      ) {
        return;
      }

      this.showErrors = false;
      this.isProcessing = true;

      let parameterType: string | null = null;

      if (isModuleTypeRequired) {

        parameterType =
          this.selectedModuleType ?? null;

      } else if (
        this.selectedReportType === 'DOCS' ||
        this.selectedReportType === 'FORMS'
      ) {

        parameterType = this.selectedReportType;
      }

      this.appService
        .getOneQmsSwitchUserLogVw(
          parameterType,
          this.selectedGroupValue ?? null,
          this.getSelectedTaskNo != undefined &&
            this.getSelectedTaskNo != ''
            ? this.getSelectedTaskNo
            : null
        )
        .subscribe((data: any) => {

          this.getOneQmsSwitchUserLogVw = data;

          console.log(
            'data==1223',
            this.getOneQmsSwitchUserLogVw
          );

          this.calculateTotalPages =
            this.collectionSize / this.perPage;

          this.pager.totalPages = undefined;

          this.collectionSize =
            this.getOneQmsSwitchUserLogVw.length;

          this.totalPages = Math.ceil(
            this.getOneQmsSwitchUserLogVw.length /
            this.itemsPerPage
          );

          this.setPage5(1, 0);

          this.showNoRecordFoundSwitchUserLog =
            this.getOneQmsSwitchUserLogVw.length === 0;

          this.isProcessing = false;
        });
    }
  }
  resetFunctions() {
    this.oneQmsUsersFieldData = { managerName: '', managerId: null };
    this.selectedTimeRangeType = null;
    this.fromDate = null;
    this.toDate = null;
    this.tableReportUserLoginFailedDataList = [];
    this.showNoRecordFoundLoginFailed = false;
    this.isProcessing = false;
    const userNameField = document.getElementById('userName') as HTMLInputElement;
    if (userNameField) {
      userNameField.style.color = '';
    }
    this.reportSearchText = '';
    this.selectedModuleType = "";
    this.showErrors = false;
    this.getSelectedTaskId = [];
    this.selectedReportType = '';
    this.tableReportUserLoginFailedDataList = [];
    this.tableReportUserPasswordChangesDataList = [];
    this.tableReportUserActiveUserDataList = [];
    this.showNoRecordFoundUserVsActivity = false;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.showTable = false;
    this.tableReportUserActivityMappingDataList = null;
    this.tableReportUserActiveUserDataList = null;
    this.managerName = "";
    this.managerId = "";
    this.getSelectedTrainingName = "";
    this.showNoRecordFoundSwitchUserLog = false;
    this.getOneQmsSwitchUserLogVw = [];
    this.reportModuleValue = "";
    this.getSelectedTaskId = null;
    this.getSelectedTaskNo = null;
    this.dmsGroupFoldersFieldData.folderName = "";
    this.selectedGroupValue = null;
    this.oneQmsUsersFieldData = { managerId: "", managerName: "" };
    this.pagedItems = [];
    this.pagedItems1 = [];
    this.pagedItems2 = [];
    this.pagedItems3 = [];
    this.pagedItems4 = [];
    [this.oneQmsUsersFieldData.managerId, this.oneQmsUsersFieldData.managerName] = [null, ''];

    // Reinitialize timeListDropdown if needed
    if (this.qmsservice.adminReportFor == 'Login Failed Attempts' || this.qmsservice.adminReportFor == 'User Login') {
      this.timeListDropdown = [
        { valueExp: 'Last 30 Days', displayExp: 'Last 30 Days' },
        { valueExp: 'Last 60 Days', displayExp: 'Last 60 Days' },
        { valueExp: 'Last 90 Days', displayExp: 'Last 90 Days' },
        { valueExp: 'Last 6 Months', displayExp: 'Last 6 Months' },
        { valueExp: 'Last One Year', displayExp: 'Last One Year' },
      ];
    }
  }
  resetFunction() {
    this.selectedOption = 'user';
    this.oneQmsUsersFieldData = { managerName: '', managerId: null };
    this.timeRangeToggle = false;
    this.selectedTimeRangeType = null;
    this.fromDate = null;
    this.toDate = null;
    this.tableReportUserLoginFailedDataList = [];
    this.showNoRecordFoundLoginFailed = false;
    this.isProcessing = false;
    const userNameField = document.getElementById('userName1') as HTMLInputElement;
    if (userNameField) {
      userNameField.style.color = '';
    }
    this.reportSearchText = '';
    this.selectedModuleType = "";
    this.showErrors = false;
    this.getSelectedTaskId = [];
    this.selectedReportType = '';
    this.tableReportUserLoginFailedDataList = [];
    this.tableReportUserPasswordChangesDataList = [];
    this.tableReportUserActiveUserDataList = [];
    this.showNoRecordFoundUserVsActivity = false;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.showTable = false;
    this.tableReportUserActivityMappingDataList = null;
    this.tableReportUserActiveUserDataList = null;
    this.managerName = "";
    this.managerId = "";
    this.getSelectedTrainingName = "";
    this.showNoRecordFoundSwitchUserLog = false;
    this.getOneQmsSwitchUserLogVw = [];
    this.reportModuleValue = "";
    this.getSelectedTaskId = null;
    this.getSelectedTaskNo = null;
    this.dmsGroupFoldersFieldData.folderName = "";
    this.selectedGroupValue = null;
    this.oneQmsUsersFieldData = { managerId: "", managerName: "" };
    this.pagedItems = [];
    this.pagedItems1 = [];
    this.pagedItems2 = [];
    this.pagedItems3 = [];
    this.pagedItems4 = [];
    [this.oneQmsUsersFieldData.managerId, this.oneQmsUsersFieldData.managerName] = [null, ''];

    // Reinitialize timeListDropdown if needed
    if (this.qmsservice.adminReportFor == 'Login Failed Attempts' || this.qmsservice.adminReportFor == 'User Login') {
      this.timeListDropdown = [
        { valueExp: 'Last 30 Days', displayExp: 'Last 30 Days' },
        { valueExp: 'Last 60 Days', displayExp: 'Last 60 Days' },
        { valueExp: 'Last 90 Days', displayExp: 'Last 90 Days' },
        { valueExp: 'Last 6 Months', displayExp: 'Last 6 Months' },
        { valueExp: 'Last One Year', displayExp: 'Last One Year' },
      ];
    }
  }
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement | null;

    if (field) {
      field.style.color = items ? '#005c8a' : 'red';
    }
  }

  @ViewChild('searchManager', { static: true }) searchManager: TemplateRef<any>;
  visibleSearchManagerPopup: MatDialogRef<TemplateRef<any>>;
  searchManagerConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  @ViewChild('searchusers', { static: true }) searchusers: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;
  searchUserConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  @ViewChild('searchModuleID', { static: true }) searchModuleID: TemplateRef<any>;
  visibleSearchModuleIDPopup: MatDialogRef<TemplateRef<any>>;
  searchModuleIDConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };



  searchManagerDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      for (const userDetail of this.getOneQmsUsersVwDetailsTableData) {
        userDetail.searchManagerChildCheckBoxs = true;
      }
    } else {
      for (const userDetail of this.getOneQmsUsersVwDetailsTableData) {
        userDetail.searchManagerChildCheckBoxs = false;
      }
    }
  }

  selectBoxForDesignation() {
    for (const designation of this.dropDownForDesignationCode) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: designation.codelistCode,
        displayExp: designation.codelistName
      });
    }
  }

  selectBoxForDepartment() {
    for (const department of this.dropDownForDepartmentCode) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: department.codelistCode,
        displayExp: department.codelistName
      });
    }
  }
  onDesignationSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedDesignationValue = item.valueExp;
    }
  }
  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedDepartmentValue = item.valueExp;
    }
  }
  searchManagerChildCheckBoxCheckedForRMVSUser(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getOneQmsUsersVwDetailsTableData[this.privvalue].searchManagerChildCheckBox = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBox = true;
      this.managerId = listOfUsersVwDetails.userId;
      this.managerName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBox = false;
      this.managerId = null;
      this.managerName = '';
    }
    this.privvalue = idx;
  }
  searchManagerChildCheckBoxChecked(e: any, listOfUsersData: any, idx: any) {
    if (e.target.checked) {
      listOfUsersData.searchManagerChildCheckBoxs = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.userId === listOfUsersData.userId)) {
        this.multiUsersArray.push({ userId: listOfUsersData.userId, userName: listOfUsersData.userName });
      }
      this.getOneQmsUsersVwDetailsTableData.every((allUsers: any) => { if (allUsers.searchUserChildCheckBox) { this.searchUserParentCheckBox = true; } return true; })
    } else {
      listOfUsersData.searchManagerChildCheckBoxs = false;
      const removal = this.getOneQmsUsersVwDetailsTableData.findIndex((removableUser: any) => removableUser.userId == listOfUsersData.userId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);

      if (this.getOneQmsUsersVwDetailsTableData.some((allUsers: any) => !allUsers.searchUserChildCheckBox)) {
        this.searchUserParentCheckBox = false;
      }
    }
  }

  searchuserFunction() {
    this.multiUsersArray = [];
    this.searchManagerChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.managerName = "";
    this.managerId = "";
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupDataTitle.title = "Search ";
    this.oneQmsUsersFieldData = { managerId: "", managerName: "" };
    this.visibleSearchUserPopup = this.dialog.open(this.searchusers, this.searchUserConfig);
  }
  searchManagerFunction() {
    this.searchManagerChildCheckBox = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupDataTitle.title = "Search ";
    this.visibleSearchManagerPopup = this.dialog.open(this.searchManager, this.searchManagerConfig);
  }
  getSelectedTaskId: any;
  getSelectedTaskNo: any;
  getTaskDetailsObj: any = [];
  getTaskDetailsObj1: any = [];


  searchTaskVwChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      if (this.privvalue != undefined) {
        this.getTaskDetailsObj1[this.privvalue].searchManagerChildCheckBoxs = false;
      }
      listOfUsersVwDetails.searchManagerChildCheckBoxs = true;
      this.getSelectedTaskId = listOfUsersVwDetails.taskId;
      this.getSelectedTaskNo = listOfUsersVwDetails.taskNo;
    } else {
      listOfUsersVwDetails.searchManagerChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }
    this.privvalue = idx;
  }
  applyFilter10(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj;
    } else {
      this.getTaskDetailsObj1 = this.getTaskDetailsObj.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (typeof columnValue === 'string') {
          console.log("columnValue1=", columnValue);
          return columnValue.toLowerCase().includes(filter);
        }
        return false;
      });
    }
  }

  multiUsersArray: any = [];
  toggleSelectAll(e: any) {
    if (e.target.checked) {
      this.multiUsersArray = [];
      this.getOneQmsUsersVwDetailsTableData.every((user: any) => {
        if (user.emailAddress) {
          user.searchManagerChildCheckBoxs = true;
          this.multiUsersArray.push({ userId: user.userId, userName: user.userName });
        }
        return true;
      })
    } else {
      this.multiUsersArray = [];
      this.getOneQmsUsersVwDetailsTableData.every((user: any) => {
        if (user.emailAddress) { user.searchManagerChildCheckBoxs = false; } return true;
      })
    }
  }

  addUserNameFunction() {
    this.oneQmsUsersFieldData.managerId = this.multiUsersArray.map((users: any) => users.userId).join(',');
    this.oneQmsUsersFieldData.managerName = this.multiUsersArray.map((users: any) => users.userName).join(',');
    console.log("data==", this.oneQmsUsersFieldData.managerId)
    console.log("data==", this.oneQmsUsersFieldData.managerName)
    this.onNgModelChange(this.oneQmsUsersFieldData.managerName, 'userName');
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchUserPopup.close();
  }
  addManagerNameFunction() {
    console.log("data==", this.managerId)
    console.log("data==", this.managerName)
    this.onNgModelChange(this.managerName, 'userName');
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchManagerPopup.close();
  }
  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
    this.visibleSearchUserPopup.close();
  }
  addTaskVwGridDataFunction() {
    this.visibleSearchModuleIDPopup.close();
  }
  cancelSearchModuleIDFunction() {
    this.visibleSearchModuleIDPopup.close();
  }
  cancelSearchManagerFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchManagerPopup.close();
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Create User" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Manager" ? "Update User" : "";
    }
  }
  searchUserGridDataFunction() {
    this.isProcessing = true;
    if (this.searchByDesignationCode) {
      this.designationCodeValue = this.searchByDesignationCode;
    } else {
      this.designationCodeValue = null;
    }
    if (this.searchByDepartmentCode) {
      this.departmentCodeValue = this.searchByDepartmentCode;
    } else {
      this.departmentCodeValue = null;
    }
    if (this.searchByUserName) {
      this.searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: this.searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByemailAddress,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }


  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  searchGridFunction() {
    this.isProcessing = true;
    if (this.searchByDesignationCode) {
      this.designationCodeValue = this.searchByDesignationCode;
    } else {
      this.designationCodeValue = null;
    }
    if (this.searchByDepartmentCode) {
      this.departmentCodeValue = this.searchByDepartmentCode;
    } else {
      this.departmentCodeValue = null;
    }
    this.searchOneQmsUserVwDetails = {

      userName: this.searchByUserName.toUpperCase(),
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue
    };
  }
  applyFilter4(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.tableReportUserLoginFailedDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.tableReportUserLoginFailedDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'dd-MMM-yyyy' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter5(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems2 = this.tableReportUserPasswordChangesDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems2 = this.tableReportUserPasswordChangesDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'dd-MMM-yyyy' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter6(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems3 = this.tableReportUserActiveUserDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems3 = this.tableReportUserActiveUserDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'dd-MMM-yyyy' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter7(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems4 = this.tableReportUserActivityMappingDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems4 = this.tableReportUserActivityMappingDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'dd-MMM-yyyy' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }


  applyFilter2(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems5 = this.getOneQmsSwitchUserLogVw.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems5 = this.getOneQmsSwitchUserLogVw.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'dd-MMM-yyyy' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  //dynamic grid
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let modifiedColumnName = colunName;
    // Modify the column name if it's "FUNC_ROLES" or "DOCUMENT_USER_ROLES"
    switch (colunName) {
      case "FUNC_ROLES":
        modifiedColumnName = "Functional Roles";
        break;
      case "DOCUMENT_USER_ROLES":
        modifiedColumnName = "Document User Roles";
        break;
      case "TRAINING_USER_ROLES":
        modifiedColumnName = "Training User Roles";
        break;
      case "QUALITY_USER_ROLES":
        modifiedColumnName = "Quality User Roles";
        break;
      case "TRAINING_AUTHOR_CATEGORIES":
        modifiedColumnName = "Training Author Categories";
        break;
      case "TRAINING_REVIEWER_APPROVER_CATEGORIES":
        modifiedColumnName = "Training Reviewer Approver Categories";
        break;
      case "TRAINING_OWNER_CATEGORIES":
        modifiedColumnName = "Training Owner Categories";
        break;
      default:
        break;
    }
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName,
    };
    console.log("popview", modifiedColumnName);
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, modifiedColumnName);
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tmsUserTrainingsRepVwDataForGrid.length, page, this.perPage, targetpage);
    if (this.tmsUserTrainingsRepVwDataForGrid.length > 0) {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid
        .slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  columnsListForExcel: any;
  fieldLabelsListForExcel: any;
  getcallMethod() {
    console.log(this.oneQmsUsersFieldData.managerId);
    if (this.oneQmsUsersFieldData.managerId) {
      this.managerId = this.oneQmsUsersFieldData.managerId;
      console.log(this.oneQmsUsersFieldData.managerId);
    } else if (this.managerId && (this.qmsservice.adminReportFor == 'QMS User Group' || this.qmsservice.adminReportFor == 'TMS User Group')) {

      console.log(this.managerId);
    } else {
      this.managerId = null;
    }
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: this.dynamicGridName,
      groupId: null,
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        console.log("this.managerId=", this.managerId);
        this.columnsListForExcel = response.columnsList ?? "";
        this.fieldLabelsListForExcel = response.fieldLabelsList ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: this.managerId == null || this.managerId == undefined ? "" : this.managerId.toString(),
          selectedGroupValue: this.selectedGroupValueDynamicGridInput,
          reportModuleValue: this.reportModuleValueDynamicGridInput,
          typeAdminReport: this.typeAdminReport,
          selectedTrainingId: this.getSelectedTrainingIdDynamicGridInput,
          selectedFolderId: this.selectedFolderId ?? null,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""

        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            this.showNoRecordFoundimg = this.tmsUserTrainingsRepVwDataForGrid.length === 0;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];

            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];


            for (const fieldSize of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(
                `${fieldSize}px`
              );
            }
            for (const invisibleColumn of this.columnLists.invisibleColumnarray) {

              const index =
                this.columnLists.columnsListarray.indexOf(
                  invisibleColumn
                );

              if (index !== -1) {

                this.columnLists.columnsListarray.splice(index, 1);

                this.columnLists.fieldColumnarray.splice(index, 1);

                this.columnLists.fieldSizeListArray.splice(index, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {

                  if (
                    dataType.columnName ===
                    this.columnLists.columnsListarray[m]
                  ) {

                    this.columnLists.columnsListarray1[m].dataType =
                      dataType.fieldType;
                  }
                }
              }
              for (const trainingData of this.tmsUserTrainingsRepVwDataForGrid) {

                for (const dataType of this.dataTypeList) {

                  if (dataType.fieldType === 'CHECKBOX') {

                    trainingData[dataType.columnName] =
                      trainingData[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  applyFilter33(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }
  applyFilter3(column: string, event: Event, val: string): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) => {
        const columnValue = item[column];

        if (columnValue == null) {
          return false;
        }

        // Handle different data types for filtering
        if (val === 'd') {
          // Handle date filtering
          const formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
          return formattedDate ? formattedDate.toLowerCase().includes(filter) : false;
        } else if (typeof columnValue === 'string') {
          // Handle string filtering
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Handle number filtering
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Handle date filtering for Date instances
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }

        // If it's an unknown data type, return false to exclude it from filtering
        return false;
      });
    }
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }
  visibleAddButton: boolean;
  visibleEditButton: boolean;

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  moduleValueRequiredMsg: any;
  callModuleSelectBoxValues() {
    if (!Array.isArray(this.dropDownDataForModule)) {
      console.error('dropDownDataForModule is not an array:', this.dropDownDataForModule);
      return;
    }

    for (const module of this.dropDownDataForModule) {
      if (module.codelistName !== "Documents" && module.codelistName !== "Trainings") {
        this.moduleListDropdown = this.moduleListDropdown.concat({
          valueExp: module.codelistCode,
          displayExp: module.codelistName
        });
      }
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('groupNameAlert', item)
    }
  }

  onModuleSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.handleDropDownValidation('groupNameAlert', item)
      this.selectedModuleDisplayExp = item.displayExp;
      this.selectedModuleValueExp = item.valueExp;
      if (this.moduleValueRequiredMsg != undefined) {
        this.moduleValueRequiredMsg.style.color = '';
      }
    }
  }

  selectBoxeForGroupValue() {
    if (this.qmsservice.adminReportFor == 'QMS User Group') {
      for (const groupData of this.groupdataList) {
        this.groupValueDropdown = this.groupValueDropdown.concat({
          valueExp: groupData.groupId,
          displayExp: groupData.groupName
        });
      }
      console.log("this.groupValueDropdown=", this.groupValueDropdown);
    }
    if (this.qmsservice.adminReportFor == 'TMS User Group') {
      console.log("this.groupdataListTms=", this.groupdataListTms);
      for (const groupData of this.groupdataListTms) {
        this.groupValueDropdownTms = this.groupValueDropdownTms.concat({
          valueExp: groupData.groupId,
          displayExp: groupData.groupName
        });
      }
      console.log("this.groupValueDropdownTms=", this.groupValueDropdownTms);
    }
    if (this.qmsservice.adminReportFor == 'DMS User Group') {
      console.log("this.groupValueDropdownDms=", this.groupdataListDms);
      for (const groupData of this.groupdataListDms) {
        this.groupValueDropdownDms = this.groupValueDropdownDms.concat({
          valueExp: groupData.groupId,
          displayExp: groupData.groupName
        });
      } console.log("this.groupValueDropdownDms=", this.groupValueDropdownDms);
    }

    if (this.qmsservice.adminReportFor == 'Switch User Log') {
      for (const groupData of this.groupdataList) {
        this.groupValueDropdown = this.groupValueDropdown.concat({
          valueExp: groupData.groupId,
          displayExp: groupData.groupName
        });
      }

      this.reportListDropdown = [
        { valueExp: 'qualityIssue', displayExp: 'Quality' },
        { valueExp: 'FORMS', displayExp: 'Forms and Log' },
        { valueExp: 'training', displayExp: 'Training' },
        { valueExp: 'DOCS', displayExp: 'Document' }

      ];
      this.reportmoduleListDropdown = [

        { valueExp: 'CR', displayExp: 'Change Request' },
        { valueExp: 'CAPA', displayExp: 'CAPA' },
        { valueExp: 'DV', displayExp: 'Deviation' },
        { valueExp: 'AU', displayExp: 'Audit' },
        { valueExp: 'CC', displayExp: 'Customer Complain' },
        { valueExp: 'IN', displayExp: 'Incident' },
        { valueExp: 'QI', displayExp: 'Quality Issue' }

      ];
      this.reportTrainingDropdown = [
        { valueExp: 'Instructor Training', displayExp: 'Instructor Training' },
        { valueExp: 'TRN', displayExp: 'Training' },
      ]

      console.log("this.groupValueDropdown=", this.groupValueDropdown);
    }
    if (this.qmsservice.adminReportFor == 'Login Failed Attempts' || this.qmsservice.adminReportFor == 'User Login') {



      this.timeListDropdown = [
        { valueExp: 'Last 30 Days', displayExp: 'Last 30 Days' },
        { valueExp: 'Last 60 Days', displayExp: 'Last 60 Days' },
        { valueExp: 'Last 90 Days', displayExp: 'Last 90 Days' },
        { valueExp: 'Last 6 Months', displayExp: 'Last 6 Months' },
        { valueExp: 'Last One Year', displayExp: 'Last One Year' },

      ];

    }
  }
  handleDropDownValidation(fieldId: string, selectedItems: any[]) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isExeclPdf = ['execl-pdf'].includes(fieldId);
    const isSelected = isExeclPdf ? !selectedItems.length : !selectedItems;
    const isFieldValid = field;
    if (isSelected && isFieldValid) {
      field.style.color = 'red';
    } else {
      field.style.color = '#005c8a';
    }
  }
  @ViewChild('searchTraining', { static: true }) searchTraining: TemplateRef<any>;
  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;

  searchByTrainingName: any = null;
  searchByTrainingCode: any = null;
  searchByCategory: any = null;
  searchByLanguage: any = null;
  categoryValue: any;
  languageValue: any;
  searchTmsTrainingsVwDetails: any;
  getTmsTrainingDetailsTableData: any = [];
  getSelectedTrainingId: any;
  getSelectedTrainingName: string;
  getSelectedVersion: any;
  noUserAlert: boolean = false;
  selectedCategoryValue: any;
  selectedLanguageValue: any;
  selectedLevelValue: any;
  selectedTemplateValue: any;
  categoryDropdown: any = [];
  languageDropdown: any = [];
  dropDownForCategories: any = [];
  getTmsInstructorTrainerData: any = [];
  dropDownForLangauge: any = [];
  onCategoryRemoved(item: any) { }
  onLangaugeRemoved(item: any) { }
  afterClickGenrate: boolean = false;
  searchVals: any;
  searchTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  searchTrainingFunction() {
    this.showUserSearchGrid = false;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.popupDataTitle.title = "Search Training";
    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTraining, this.searchTrainingConfig);
  }
  cancelSearchTrainingFunction() {
    this.getSelectedTrainingId = null;
    this.getSelectedTrainingName = '';
    this.getSelectedVersion = null;
    this.noUserAlert = false;
    this.visibleSearchTrainingPopup.close();
  }
  selectBoxeForCategory() {
    for (const category of this.dropDownForCategories) {
      this.categoryDropdown = this.categoryDropdown.concat({
        valueExp: category.trainingCategoryCode,
        displayExp: category.trainingCategoryName
      });
    }
  }
  selectBoxeForLanguage() {
    for (const language of this.dropDownForLangauge) {
      this.languageDropdown = this.languageDropdown.concat({
        valueExp: language.codelistCode,
        displayExp: language.codelistName
      });
    }
  }
  searchTrainingGridDataFunction() {
    this.isProcessing = true;
    if (this.searchByCategory) {
      this.categoryValue = this.searchByCategory;
    } else {
      this.categoryValue = null;
    }
    if (this.searchByLanguage) {
      this.languageValue = this.searchByLanguage
    } else {
      this.languageValue = null;
    }
    this.searchTmsTrainingsVwDetails = {
      trainingName: this.searchByTrainingName,
      trainingCode: this.searchByTrainingCode,
      category: this.categoryValue,
      language: this.languageValue,
      groupId: null
    };
    this.appService.searchTrainingsByCondition(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsTrainingDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }
  resetSearchTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.getTmsTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  searchTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      this.getSelectedTrainingId = listOfTrainingsVwDetails.trainingId;
      this.getSelectedTrainingName = listOfTrainingsVwDetails.trainingName;
      console.log(this.getSelectedTrainingId);
      this.getSelectedVersion = listOfTrainingsVwDetails.version;
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      this.getSelectedTrainingId = null;
      this.getSelectedTrainingName = '';
      this.getSelectedVersion = null;
    }
  }

  addTrainingNameFunction() {
    this.afterClickGenrate = false;
    this.noUserAlert = false;
    console.log(this.getSelectedTrainingId);

    this.searchVals = this.getSelectedTrainingId;
    if (this.searchVals != "" && this.searchVals != null && this.searchVals != undefined) {
      this.visibleSearchTrainingPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  dmsGroupFoldersFieldData: any = {};
  visibleSearchFoldersPopup: MatDialogRef<TemplateRef<any>>;
  visibleDmsGroupFoldersReasonForUpdateField: boolean;
  @ViewChild('searchFoldersPopup', { static: true }) searchFoldersPopup: TemplateRef<any>;
  searchFoldersPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addFolderFunction() {
    this.dmsGroupFoldersFieldData.folderId = this.selectedFolderForCreateDoc.folderId;
    this.dmsGroupFoldersFieldData.folderName = this.selectedFolderForCreateDoc.folderName;
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
    }
    this.visibleSearchFoldersPopup.close();
  }
  model = {
    documentData: {},
  };
  selectedFolderForCreateDoc: any = {};
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;
  }
  cancelSeachFoldersFunction() {
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
    }
    this.visibleSearchFoldersPopup.close();
  }
  getDmsFoldersVwDetails: any = [];
  searchDocumentFunction() {
    this.popupDataTitle.title = "Search Folders";
    this.visibleSearchFoldersPopup = this.dialog.open(this.searchFoldersPopup, this.searchFoldersPopupConfig);
  }
  moreAdminReportDetails(value: any) {
    this.qmsservice.adminReportFor = value;
    if (value == 'Default') {
      this.message.breadcrumbData.thirdLevel = "";
      this.router.navigate(['/dashboard/OneQmsAdminReportComponent']);
      this.showTable = false;
    } else {
      if (this.qmsservice.adminReportFor == 'QMS User Group') {
        this.isProcessing = true;
        forkJoin([
          this.appService.getQmsGroups(),
          this.appService.getCodeListsByGroup(
            "MODULES"
          )
        ]).subscribe({
          next: ([groupdataList, moduleData]) => {

            this.dropDownDataForModule = moduleData;

            this.callModuleSelectBoxValues();

            this.groupdataList = groupdataList;

            this.selectBoxeForGroupValue();

            this.isProcessing = false;
          },

          error: (error) => {

            console.error(
              'Error in forkJoinObservable:',
              error
            );

            this.isProcessing = false;
          }
        });
      } else if (this.qmsservice.adminReportFor == 'TMS User Group') {
        this.isProcessing = true;
        forkJoin([
          this.appService.getTmsGroupsVwDetails(

          ),

          this.appService.getCategoriesList(),

          this.appService.getCodeListsByGroup(
            "TRAINING_LANGUAGE"
          )
        ]).subscribe({

          next: ([groupdataList, data, data1]) => {

            this.dropDownForCategories = data;

            this.selectBoxeForCategory();

            this.dropDownForLangauge = data1;

            this.selectBoxeForLanguage();

            this.groupdataListTms = groupdataList;

            console.log(
              "this.groupdataListTms=",
              this.groupdataListTms
            );

            this.selectBoxeForGroupValue();

            this.isProcessing = false;
          },

          error: (error) => {

            console.error(
              'Error in forkJoinObservable:',
              error
            );

            this.isProcessing = false;
          }
        });
      } else if (this.qmsservice.adminReportFor == 'DMS User Group') {
        this.isProcessing = true;
        forkJoin([
          this.appService.getDmsGroupsVwDetails(

          )
        ]).subscribe({

          next: ([groupdataList]) => {

            this.groupdataListDms = groupdataList;

            this.selectBoxeForGroupValue();

            this.isProcessing = false;
          },

          error: (error) => {

            console.error(
              'Error in forkJoinObservable:',
              error
            );

            this.isProcessing = false;
          }
        });
      } else if (this.qmsservice.adminReportFor == 'Switch User Log') {
        this.isProcessing = true;

        forkJoin([
          this.appService.getQmsGroups(
          ),

          this.appService.getCodeListsByGroup(
            "MODULES"
          )
        ]).subscribe({

          next: ([groupdataList, moduleData]) => {

            this.dropDownDataForModule = moduleData;

            this.callModuleSelectBoxValues();

            this.groupdataList = groupdataList;

            this.selectBoxeForGroupValue();

            this.isProcessing = false;
          },

          error: (error) => {

            console.error(
              'Error in forkJoinObservable:',
              error
            );

            this.isProcessing = false;
          }
        });

        this.reportListDropdown = [
          {
            valueExp: 'qualityIssue',
            displayExp: 'Quality'
          },
          {
            valueExp: 'FORMS',
            displayExp: 'Forms and Log'
          },
          {
            valueExp: 'training',
            displayExp: 'Training'
          },
          {
            valueExp: 'DOCS',
            displayExp: 'Document'
          }
        ];
      } else if (this.qmsservice.adminReportFor == 'Login Failed Attempts' || this.qmsservice.adminReportFor == 'User Login') {
        // Initialize timeListDropdown for Login Failed Attempts and User Login
        this.timeListDropdown = [
          { valueExp: 'Last 30 Days', displayExp: 'Last 30 Days' },
          { valueExp: 'Last 60 Days', displayExp: 'Last 60 Days' },
          { valueExp: 'Last 90 Days', displayExp: 'Last 90 Days' },
          { valueExp: 'Last 6 Months', displayExp: 'Last 6 Months' },
          { valueExp: 'Last One Year', displayExp: 'Last One Year' },
        ];
        console.log('TimeListDropdown initialized in moreAdminReportDetails:', this.timeListDropdown);
      }
      this.resetFunction();
      this.qmsservice.adminReportFor = value;
      this.message.breadcrumbData.thirdLevel = value;
      this.router.navigate(['/dashboard/OneQmsMoreAdminReportDetailsComponent']);
      this.breadcrumbComponent.thirdLevel = value;
      this.showTable = false;
      this.showTable = false;
      this.tableReportUserActivityMappingDataList = null;
      this.tableReportUserActiveUserDataList = null;
      this.managerName = "";
      this.managerId = "";
      this.reportModuleValue = "";
      this.getSelectedTrainingName = "";
      this.getSelectedTaskId = "";
      this.dmsGroupFoldersFieldData.folderName = "";
      this.selectedGroupValue = null;
      this.oneQmsUsersFieldData = { managerId: "", managerName: "" };
      this.pagedItems = [];
      this.pagedItems1 = [];
      this.pagedItems2 = [];
      this.pagedItems3 = [];
      this.pagedItems4 = [];
      [this.oneQmsUsersFieldData.managerId, this.oneQmsUsersFieldData.managerName] = [null, ''];
    }
  }

  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);
          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsservice.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }

  organizationPrivelegesDetails: any = [];
  isQMS: boolean = false;
  isDMS: boolean = false;
  isTRN: boolean = false;
  ngOnInit() {
    // Initialize timeListDropdown first for Login Failed Attempts and User Login reports
    if (this.qmsservice.adminReportFor == 'Login Failed Attempts' || this.qmsservice.adminReportFor == 'User Login') {
      this.timeListDropdown = [
        { valueExp: 'Last 30 Days', displayExp: 'Last 30 Days' },
        { valueExp: 'Last 60 Days', displayExp: 'Last 60 Days' },
        { valueExp: 'Last 90 Days', displayExp: 'Last 90 Days' },
        { valueExp: 'Last 6 Months', displayExp: 'Last 6 Months' },
        { valueExp: 'Last One Year', displayExp: 'Last One Year' },
      ];
      console.log('TimeListDropdown initialized:', this.timeListDropdown);
    }

    if (this.qmsservice.adminReportFor == 'Concurrent users / Active login sessions') {
      let data = {

      }
      this.isProcessing = true;
      forkJoin([
        this.appService.getOneQmsUserActiveUserRep(data)]).subscribe(([dataList]) => {
          this.tableReportUserActiveUserDataList = dataList;
          this.showNoRecordFoundConcurrent = this.tableReportUserActiveUserDataList.length === 0;
          this.isProcessing = false;
        });
    } else if (this.qmsservice.adminReportFor == 'QMS User Group') {
      this.isProcessing = true;
      forkJoin([
        this.appService.getQmsGroups(),
        this.appService.getCodeListsByGroup("MODULES"),
      ]).subscribe(([groupdataList, moduleData]) => {
        this.dropDownDataForModule = moduleData;
        this.callModuleSelectBoxValues();
        this.groupdataList = groupdataList;
        this.selectBoxeForGroupValue();
        this.isProcessing = false;
      })
    } else if (this.qmsservice.adminReportFor == 'TMS User Group') {
      this.isProcessing = true;
      forkJoin([
        this.appService.getTmsGroupsVwDetails(),
        this.appService.getCategoriesList(),
        this.appService.getCodeListsByGroup("TRAINING_LANGUAGE")
      ]).subscribe(([groupdataList, data, data1]) => {
        this.dropDownForCategories = data;
        this.selectBoxeForCategory();
        this.dropDownForLangauge = data1;
        this.selectBoxeForLanguage();
        this.groupdataListTms = groupdataList;
        this.selectBoxeForGroupValue();
        this.isProcessing = false;
      })
    } else if (this.qmsservice.adminReportFor == 'DMS User Group') {
      this.isProcessing = true;
      forkJoin([
        this.appService.getDmsGroupsVwDetails(),
      ]).subscribe(([groupdataList]) => {
        this.groupdataListDms = groupdataList;
        this.selectBoxeForGroupValue();
        this.isProcessing = false;
      })
    } else if (this.qmsservice.adminReportFor == 'Switch User Log') {
      this.isProcessing = true;
      forkJoin([
        this.appService.getQmsGroups(),
        this.appService.getCodeListsByGroup("MODULES"),
      ]).subscribe(([groupdataList, moduleData]) => {
        this.dropDownDataForModule = moduleData;
        this.callModuleSelectBoxValues();
        this.groupdataList = groupdataList;
        this.selectBoxeForGroupValue();
        this.isProcessing = false;
      })

      this.reportListDropdown = [
        { valueExp: 'qualityIssue', displayExp: 'Quality' },
        { valueExp: 'FORMS', displayExp: 'Forms and Log' },
        { valueExp: 'training', displayExp: 'Training' },
        { valueExp: 'DOCS', displayExp: 'Document' }

      ];
      this.reportmoduleListDropdown = [

        { valueExp: 'CR', displayExp: 'Change Request' },
        { valueExp: 'CAPA', displayExp: 'CAPA' },
        { valueExp: 'DV', displayExp: 'Deviation' },
        { valueExp: 'AU', displayExp: 'Audit' },
        { valueExp: 'CC', displayExp: 'Customer Complain' },
        { valueExp: 'IN', displayExp: 'Incident' },
        { valueExp: 'QI', displayExp: 'Quality Issue' }

      ];
      this.reportTrainingDropdown = [
        { valueExp: 'Instructor Training', displayExp: 'Instructor Training' },
        { valueExp: 'TRN', displayExp: 'Training' },
      ]
    } else if (this.qmsservice.adminReportFor == 'Login Failed Attempts' || this.qmsservice.adminReportFor == 'User Login') {



      this.timeListDropdown = [
        { valueExp: 'Last 30 Days', displayExp: 'Last 30 Days' },
        { valueExp: 'Last 60 Days', displayExp: 'Last 60 Days' },
        { valueExp: 'Last 90 Days', displayExp: 'Last 90 Days' },
        { valueExp: 'Last 6 Months', displayExp: 'Last 6 Months' },
        { valueExp: 'Last One Year', displayExp: 'Last One Year' },

      ];

    }
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();


    this.ngOnChangesReportFooter();

    this.appService.getOneQmsOrganizationPrivileges().subscribe((data: any) => {

      if (data.cr == "Y" || data.capa == "Y" || data.dv == "Y" || data.au == "Y" || data.in == "Y" || data.qi == "Y" || data.cc == "Y" || data.OOS == "Y") {
        this.isQMS = true;
      } else {
        this.isQMS = false;
      }
      this.isTRN = data.trn == "Y";
      this.isDMS = data.docs == "Y";

      console.log(this.isQMS, "=this.isQMS");
      console.log(this.isTRN, "=data.trn");
      console.log(this.isDMS, "=data.docs");
      this.organizationPrivelegesDetails = data;

    })
  }
  get moduleDropdownList() {
    if (this.selectedReportType === 'qualityIssue') {
      return this.moduleListDropdown;
    } else if (this.selectedReportType === 'training') {
      return this.reportTrainingDropdown;
    }
    return [];
  }
  reportTrainingDropdown: any[];

  reportListDropdown: any;
  reportmoduleListDropdown: any;
  timeListDropdown: any;

  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportUserLoginFailedDataList.length, page, this.perPage, targetpage);
    if (this.tableReportUserLoginFailedDataList.length > 0) {
      this.pagedItems1 = this.tableReportUserLoginFailedDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  setPage2(page: number, targetpage: number) {
    console.log("data54321", this.pager.totalPages)
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportUserPasswordChangesDataList.length, page, this.perPage, targetpage);
    if (this.tableReportUserPasswordChangesDataList.length > 0) {
      console.log("data54321", this.tableReportUserPasswordChangesDataList)
      this.pagedItems2 = this.tableReportUserPasswordChangesDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  setPage3(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportUserActiveUserDataList.length, page, this.perPage, targetpage);
    if (this.tableReportUserActiveUserDataList.length > 0) {
      this.pagedItems3 = this.tableReportUserActiveUserDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall3(value: number) {
    this.perPage = value;
    this.setPage3(this.pager.currentPage, 0);
  }
  setPage4(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportUserActivityMappingDataList.length, page, this.perPage, targetpage);
    if (this.tableReportUserActivityMappingDataList.length > 0) {
      this.pagedItems4 = this.tableReportUserActivityMappingDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall4(value: number) {
    this.perPage = value;
    this.setPage4(this.pager.currentPage, 0);
  }

  setPage5(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.getOneQmsSwitchUserLogVw.length, page, this.perPage, targetpage);
    if (this.getOneQmsSwitchUserLogVw.length > 0) {
      this.pagedItems5 = this.getOneQmsSwitchUserLogVw.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall5(value: number) {
    this.perPage = value;
    this.setPage5(this.pager.currentPage, 0);
  }
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.dynamicGridName, this.dynamicGridViewName, null, 0)
  }
  onChildValueEmitted() {
    this.genReport();
  };
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  //Excell & PDF
  whereValsForExcel: any = "";
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }


  onModuleSelectNew(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('manageReportNameAlert', item)
    }
  }

  selectedReportType: any;

  selectedTimeRangeType: any;

  subReportTypeOptions: { [key: string]: { label: string; value: string }[] } = {


  };
  searchModuleIDFunction() {
    this.popupDataTitle.title = "Select Module ID";

    if (this.selectedReportType === 'qualityIssue') {

      if (!this.selectedModuleType) {

        alert("Please select a module before proceeding.");

        return;
      }

      const allowedModules = [
        "CR",
        "CAPA",
        "DV",
        "AU",
        "CC",
        "IN",
        "QI"
      ];

      if (!allowedModules.includes(this.selectedModuleType)) {
        return;
      }

      this.isProcessing = true;

      this.appService
        .getQmsAllTasksVw(

          this.selectedModuleType
        )
        .subscribe((data: any) => {

          this.getTaskDetailsObj = data;
          this.getTaskDetailsObj1 = data;

          this.visibleSearchModuleIDPopup =
            this.dialog.open(
              this.searchModuleID,
              this.searchModuleIDConfig
            );

          this.isProcessing = false;
        });
    } else if (this.selectedReportType === "FORMS") {
      this.isProcessing = true;
      this.appService.getQmsAllTasksVw("FRN").subscribe((data: any) => {
        this.getTaskDetailsObj = data;
        this.getTaskDetailsObj1 = data;
        this.visibleSearchModuleIDPopup = this.dialog.open(this.searchModuleID, this.searchModuleIDConfig);
        this.isProcessing = false;
      })
    } else if (this.selectedReportType === "training") {

      if (!this.selectedModuleType) {

        alert("Please select a module before proceeding.");

        return;
      }

      const moduleCodeMap: { [key: string]: string } = {
        "TRN": "TRN",
        "Instructor Training": "QI"
      };

      const moduleCode =
        moduleCodeMap[this.selectedModuleType];

      if (!moduleCode) {
        return;
      }

      this.isProcessing = true;

      this.appService
        .getQmsAllTasksVw(

          moduleCode
        )
        .subscribe((data: any) => {

          this.getTaskDetailsObj = data;
          this.getTaskDetailsObj1 = data;

          if (this.selectedModuleType === "TRN") {

            this.visibleSearchModuleIDPopup =
              this.dialog.open(
                this.searchModuleID,
                this.searchModuleIDConfig
              );

          } else if (
            this.selectedModuleType ===
            "Instructor Training"
          ) {

            this.multiUsersArray = [];

            this.getTmsInstructorTrainingDetailsTableData
              .forEach((training: any) => {

                if (training.trainingName) {
                  training.searchTrainingChildCheckBoxs = false;
                }
              });

            this.showUserSearchInstructorTrainingGrid =
              false;

            this.searchByInstructorTrainingScheduleId = "";
            this.searchByInstructorTrainingName = "";
            this.searchByVersion = "";
            this.searchByTrainerName = "";
            this.searchByTrainingMode = "";
            this.searchByStatus = "";

            this.visibleSearchInstructorTrainingPopup =
              this.dialog.open(
                this.searchInstructorTraining,
                this.searchInstructorTrainingConfig
              );
          }

          this.isProcessing = false;
        });
    } else if (this.selectedReportType === "DOCS") {
      this.isProcessing = true;
      this.appService.getQmsAllTasksVw("DOCS").subscribe((data: any) => {
        this.getTaskDetailsObj = data;
        this.getTaskDetailsObj1 = data;

        this.visibleSearchModuleIDPopup = this.dialog.open(this.searchModuleID, this.searchModuleIDConfig);
        this.isProcessing = false;
      })
    }

  }

  addInstructorTrainingNameFunction() {
    this.afterClickGenrate = false;
    this.getSelectedTaskNo = this.multiUsersArray.map((training: any) => training.trainingId).join(',');
    this.getSelectedTaskId = this.multiUsersArray.map((training: any) => training.trainingName).join(',');
    console.log(this.getSelectedTaskNo + "----" + this.getSelectedInstructorTrainingName)
    this.searchVals = this.getSelectedTaskNo;
    this.noUserAlert = false;
    if (this.searchVals != "" && this.searchVals != null && this.searchVals != undefined) {
      this.visibleSearchInstructorTrainingPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  cancelSearchInstructorTrainingFunction() {
    this.noUserAlert = false;
    this.searchByInstructorTrainingScheduleId = null;
    this.getSelectedInstructorTrainingName = '';
    this.visibleSearchInstructorTrainingPopup.close();
  }

  searchInstructorTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.trainingScheduleId === listOfTrainingsVwDetails.trainingScheduleId)) {
        this.multiUsersArray.push({ trainingId: listOfTrainingsVwDetails.trainingScheduleId, trainingName: listOfTrainingsVwDetails.trainingName });
      }
      this.getTmsInstructorTrainingDetailsTableData.every((allUsers: any) => { if (allUsers.searchTrainingChildCheckBoxs) { this.searchUserParentCheckBox = true; } return true; })
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      const removal = this.getTmsInstructorTrainingDetailsTableData.findIndex((removableUser: any) => removableUser.trainingScheduleId == listOfTrainingsVwDetails.trainingScheduleId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);

      if (this.getTmsInstructorTrainingDetailsTableData.some((allUsers: any) => !allUsers.searchTrainingChildCheckBoxs)) {
        this.searchUserParentCheckBox = false;
      }
    }
    if (e.target.checked) {
      this.searchByInstructorTrainingScheduleId = listOfTrainingsVwDetails.trainingScheduleId;
      this.getSelectedInstructorTrainingName = listOfTrainingsVwDetails.trainingName;
    } else {
      this.searchByInstructorTrainingScheduleId = null;
      this.getSelectedInstructorTrainingName = '';
    }
  }
  showInstructorTrainingSearchGrid: boolean;
  @ViewChild('searchInstructorTraining', { static: true }) searchInstructorTraining: TemplateRef<any>;
  visibleSearchInstructorTrainingPopup: MatDialogRef<TemplateRef<any>>;
  searchByInstructorTrainingName: any = null;
  searchByInstructorTrainingScheduleId: any = null;
  searchByVersion: any = [];
  searchByTrainerName: any = [];
  searchByTrainingMode: any = [];
  searchByStatus: any = [];
  searchTmsInstructorTrainingsVwDetails: any;
  getTmsInstructorTrainingDetailsTableData: any = [];
  showUserSearchInstructorTrainingGrid: any;
  getSelectedInstructorTrainingId: any;
  getSelectedInstructorTrainingName: string;
  searchInstructorTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  resetSearchInstructorTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByInstructorTrainingScheduleId = "";
    this.searchByInstructorTrainingName = "";
    this.searchByVersion = "";
    this.searchByTrainerName = "";
    this.searchByTrainingMode = "";
    this.searchByStatus = "";
    this.getTmsInstructorTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  searchInstructorTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchTmsTrainingsVwDetails = {
      trainingScheduleId: this.searchByInstructorTrainingScheduleId,
      trainingName: this.searchByInstructorTrainingName,
      version: this.searchByVersion,
      trainerName: this.searchByTrainerName,
      trainingMode: this.searchByTrainingMode,
      status: this.searchByStatus
    };
    this.appService.searchInstructorTrainingsByCondition(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsInstructorTrainingDetailsTableData = response;
      this.showInstructorTrainingSearchGrid = true;
      this.isProcessing = false;
    })
  }


  onReportTypeSelectnew(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('groupNameAlert', item)
      if (item == 'qualityIssue') {
        this.currentModuleDropdown = this.reportmoduleListDropdown;

      } else if (item == 'training') {
        this.currentModuleDropdown = this.reportTrainingDropdown;
        this.selectedGroupValue = null;
      } else {
        this.currentModuleDropdown = [];
        this.selectedGroupValue = null;
      }

    }

    this.resetFunctions();
    this.selectedModuleType = "";
  }

  currentModuleDropdown: any[] = [];
  selectedModuleType: string = '';
  filteredOptions: any[] = [];
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let orderBy = "";
      if (this.qmsservice.adminReportFor == 'Login Failed Attempts') {
        tname = "ONEQMS_USER_LOGIN_FAILED_ATTEMPTS_REP_VW";
        colList = "USER_NAME,USER_FULLNAME,LOGGED_ATTEMPTED_ON,ATTEMPT,IS_LOCKED";
        fieldList = "User Name,User Fullname,Logged Attempted On,Attempt,Is Locked";
        if (this.selectedOption === 'user') {
          if (this.oneQmsUsersFieldData.managerId) {
            console.log(this.oneQmsUsersFieldData.managerId, "====");
            this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND USER_ID IN (" + this.oneQmsUsersFieldData.managerId + ")";
          } else {
            this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
          }
        } else {
          // this.selectedTimeRangeType??null,this.fromDate??null,this.toDate ??null
          this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
          if (this.timeRangeToggle === false) {

            console.log(
              "this.selectedTimeRangeType=",
              this.selectedTimeRangeType
            );

            const timeRangeMap: { [key: string]: number } = {
              "Last 30 Days": 30,
              "Last 60 Days": 60,
              "Last 90 Days": 90,
              "Last 6 Months": 180,
              "Last One Year": 360
            };

            const days =
              timeRangeMap[this.selectedTimeRangeType];

            if (days) {

              this.whereValsForExcel +=
                ` AND TRUNC(LOGGED_ATTEMPTED_ON) >= ` +
                `(SYSDATE - ${days}) ` +
                `ORDER BY LOGGED_ATTEMPTED_ON DESC`;
            }
          } else {
            console.log("this.selectedTimeRangeType22=", this.selectedTimeRangeType);
            const formattedFromDate = formatDateToSQL(new Date(this.fromDate));
            const formattedToDate = formatDateToSQL(new Date(this.toDate));

            this.whereValsForExcel =
              this.whereValsForExcel +
              ` AND TRUNC(LOGGED_ATTEMPTED_ON) >= TO_DATE('${formattedFromDate}', 'YYYY-MM-DD HH24:MI:SS')` +
              ` AND TRUNC(LOGGED_ATTEMPTED_ON) <= TO_DATE('${formattedToDate}', 'YYYY-MM-DD HH24:MI:SS')` +
              ` ORDER BY LOGGED_ATTEMPTED_ON DESC`;
          }

        }


      } else if (this.qmsservice.adminReportFor == 'User Login') {
        tname = "ONEQMS_USER_LOGINS_REP_VW";
        colList = "USER_NAME,LOGGED_ON,LOGGED_OUT";
        fieldList = "User Name,Logged On,Logged Out";
        if (this.selectedOption === 'user') {
          if (this.oneQmsUsersFieldData.managerId) {
            console.log(this.oneQmsUsersFieldData.managerId, "====");
            this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND USER_ID IN (" + this.oneQmsUsersFieldData.managerId + ")";
          } else {
            this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
          }
        } else {

          // this.selectedTimeRangeType ?? null,
          // this.fromDate ?? null,
          // this.toDate ?? null

          this.whereValsForExcel =
            ` WHERE ORG_ID=${this.message.getOrgId()}`;

          if (this.timeRangeToggle === false) {

            console.log(
              "this.selectedTimeRangeType=",
              this.selectedTimeRangeType
            );

            const timeRangeMap: Record<string, number> = {
              "Last 30 Days": 30,
              "Last 60 Days": 60,
              "Last 90 Days": 90,
              "Last 6 Months": 180,
              "Last One Year": 360
            };

            const days =
              timeRangeMap[this.selectedTimeRangeType];

            if (days) {

              this.whereValsForExcel +=
                ` AND TRUNC(LOGGED_ON) >= ` +
                `(SYSDATE - ${days}) ` +
                `ORDER BY LOGGED_ON DESC`;
            }

          } else {

            console.log(
              "this.selectedTimeRangeType22=",
              this.selectedTimeRangeType
            );

            const formattedFromDate =
              formatDateToSQL(new Date(this.fromDate));

            const formattedToDate =
              formatDateToSQL(new Date(this.toDate));

            this.whereValsForExcel +=
              ` AND TRUNC(LOGGED_ON) >= ` +
              `TO_DATE('${formattedFromDate}', ` +
              `'YYYY-MM-DD HH24:MI:SS')` +
              ` AND TRUNC(LOGGED_ON) <= ` +
              `TO_DATE('${formattedToDate}', ` +
              `'YYYY-MM-DD HH24:MI:SS')` +
              ` ORDER BY LOGGED_ON DESC`;
          }
        }


      } else if (this.qmsservice.adminReportFor == 'User Password Changes') {
        tname = "ONEQMS_USER_PASSWORD_CHANGES_REP_VW";
        colList = "USER_NAME,USER_FULLNAME,PASSWORD_CHANGED_ON,NEXT_PASSWORD_RESET_ON";
        fieldList = "User Name,User Fullname,Password Changed On,Next Password Reset On";
        if (this.oneQmsUsersFieldData.managerId) {
          this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND USER_ID IN (" + this.oneQmsUsersFieldData.managerId + ")";
        } else {
          this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId();
        }

      } else if (this.qmsservice.adminReportFor == 'User vs RM') {
        tname = "ONEQMS_USERS_VW";
        colList = "USER_NAME,USER_FULL_NAME,IS_AD_USER,USER_DESCRIPTION,DESIGNATION,DEPARTMENT,MANAGER_NAME,EMAIL_ADDRESS,CONTACT_NUMBER,COUNTRY,CITY,TIMEZONE,IS_ACTIVE,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER";
        fieldList = "User Name,User Full Name,Is AD User,User Description,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Created On,Updated On,Created By,Updated By";
        orderBy = "USER_ID";
        if (this.managerId) {
          this.whereValsForExcel = " WHERE MANAGER_ID=" + this.managerId;
        }
      } else if (this.qmsservice.adminReportFor == 'User vs Activity') {
        this.whereValsForExcel = "";
        tname = "ONEQMS_MY_PENDING_TASKS_VW";
        colList = "MODULE_CODE,VERSION,TASK_REF_NO,TASK_NAME,SUB_TASK_NAME,SUB_MODULE_NAME,STATUS,OTHER_DETAILS,TASK_OWNER_USER_NAME,REQUESTER_USER_NAME,ACTION_REQUESTED_ON,PENDING_WITH_USER_NAMES,DUE_ON";
        fieldList = "Module Code,Version,Task Ref No,Task Name,Sub Task Name,Sub Module Name,Status,Other Details,Task Owner User Name,Requester User Name,Action Requested On,Pending With User Names,Due On";
        if (this.managerId) {
          this.whereValsForExcel = this.managerId;
        }
      } else if (this.qmsservice.adminReportFor == 'User vs Functional Roles Privilege') {
        tname = this.dynamicGridViewName;
        colList = "USER_NAME,USER_FULLNAME,IS_USER_ACTIVE,DESIGNATION,DEPARTMENT,FUNC_ROLES,APPLICATION_ADMINISTRATOR,USER_MANAGEMENT,DASHBOARD_VIEWER,TOPIC_ADMINISTRATOR,SWITCH_USER,SETUP_ADMINISTRATOR,AUDIT_TRAIL_USER,DOCUMENT_DOWNLOADER,IS_DOCUMENT_USER,DOCUMENT_USER_ROLES,ROOT_FOLDER_ADMINISTRATOR,FOLDER_GROUP_ADMINISTRATOR,DOCUMENTS_REPORT_USER,DOCUMENT_ISSUANCE_TRACKER,IS_TRAINING_USER,TRAINING_USER_ROLES,TRAINING_GROUP_ADMINISTRATOR,TRAINING_ADMINISTRATOR,USER_TRAINING_ADMINISTRATOR,TRAINING_QA_USER,PERIODIC_REVIEWER,INSTRUCTOR_TRAINING_ADMINISTRATOR,TRAINING_INSTRUCTOR,INSTRUCTOR_TRAINING_APPROVER,TRAINING_REPORT_USER,UNLOCK_TRAINING_USER,IS_QUALITY_USER,QUALITY_USER_ROLES,QUALITY_GROUP_ADMINISTRATOR,CHANGE_REQUEST_USER,CAPA_USER,DEVIATION_USER,AUDIT_USER,INCIDENT_USER,QUALITY_ISSUE_USER,CUSTOMER_COMPLAINT_USER,CR_ROLES,CR_REPORT_USER,CAPA_ROLES,CAPA_REPORT_USER,DV_ROLES,DV_REPORT_USER,AU_ROLES,AU_REPORT_USER,CC_ROLES,CC_REPORT_USER,CC_INITIATOR,IN_ROLES,IN_REPORT_USER,QI_ROLES,QI_REPORT_USER,TRAINING_AUTHOR_CATEGORIES,TRAINING_REVIEWER_APPROVER_CATEGORIES,TRAINING_OWNER_CATEGORIES,FORMS_AND_LOGS_ADMINISTRATOR,FORMS_AND_LOGS_USER,IS_BP_USER,BP_USER_ROLES,BP_ADMINISTRATOR,BP_REPORT_USER,BP_PERFORMER,BP_VERIFIER,BP_SETUP_REVIEWER,BP_SETUP_APPROVER,BP_REVIEWER,BP_APPROVER,UPDATE_REASON,UPDATED_ON,UPDATED_BY_USER";
        fieldList = "User Name,User Fullname,User Active?,Designation,Department,Functional Roles,Application Administrator,User Management,Dashboard Viewer,Topic Administrator,Switch User,Setup Administrator,Audit Trail User,Document Downloader,Document User?,Document User Roles,Root Folder Administrator,Folder Group Administrator,Documents Report User,Document Issuance Tracker,Training User?,Training User Roles,Training Group Administrator,Training Administrator,User Training Administrator,Training QA User,Periodic Reviewer,Instructor Training Administrator,Training Instructor,Instructor Training Approver,Training Report User,Unlock Training User,Quality User?,Quality User Roles,Quality Group Administrator,Change Request User,CAPA User,Deviation User,Audit User,Incident User,Quality Issue User?,Customer Complaint User,CR Roles,CR Report User,CAPA Roles,CAPA Report User,DV Roles,DV Report User,AU Roles,AU Report User,CC Roles,CC Report User,CC Initiator,IN Roles,IN Report User,QI Roles,QI Report User,Training Author Categories,Training Reviewer Approver Categories,Training Owner Categories,Forms And Logs Administrator,Forms And Logs User,Is Bp User,Bp User Roles,Bp Administrator,Bp Report User,Bp Performer,Bp Verifier,Bp Setup Reviewer,Bp Setup Approver,Bp Reviewer,Bp Approver,Update Reason,Updated On,Updated By";
        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId()
        if (this.managerId) {
          console.log("this.managerId===", this.managerId);
          this.whereValsForExcel += " AND USER_ID IN (" + this.managerId + ")";
        } else if (this.oneQmsUsersFieldData.managerId) {
          console.log("this.managerId==", this.oneQmsUsersFieldData.managerId);
          this.whereValsForExcel += " AND USER_ID IN (" + this.oneQmsUsersFieldData.managerId + ")";
        }
      } else if (this.qmsservice.adminReportFor == 'QMS User Group') {
        tname = this.dynamicGridViewName;
        colList = "GROUP_NAME,GROUP_DESCRIPTION,IS_GROUP_ACTIVE,MODULE,IS_GROUP_MODULE_ACTIVE,IS_USER_ACTIVE,USER_NAME,USER_FULLNAME,DESIGNATION,DEPARTMENT,QMS_ROLES,IS_GROUP_MODULE_USER_ACTIVE,ACTION_APPROVER,ACTION_DEFERRED_APPROVER,ACTION_DEFERRED_REVIEWER,ACTION_REVIEWER,APPROVER,AUDITOR,CLOSURE_APPROVER,CLOSURE_REVIEWER,DELETE_APPROVER,EFFECTIVENESS_CHECK_APPROVER,EFFECTIVENESS_CHECK_PERFORMER,EVALUATOR,EXTENSION_APPROVER,EXTENSION_REVIEWER,GROUP_REPORT_USER,IMPLEMENTATION_REVIEWER,INITIATOR,INVESTIGATOR,OBSOLETE_APPROVER,OBSOLETE_USER,OWNER,PEER_REVIEWER,PLAN_APPROVER,PLANNER,QA,REOPEN_APPROVER,REOPEN_USER,RESPONSE_REVIEWER,REVIEWER,REVOKE_APPROVER,REVOKE_USER,SCHEDULE_APPROVER,SCHEDULER,VIEWER,ASSIGNED_ON,ASSIGNED_BY_USER,IS_ACTIVE,INACTIVATE_REASON";
        fieldList = "Group Name,Group Description,Group Active?,Module,Group Module Active?,User Active?,User Name,User Fullname,Designation,Department,Qms Roles,Group Module User Active?,Action Approver,Action Deferred Approver,Action Deferred Reviewer,Action Reviewer,Approver,Auditor,Closure Approver,Closure Reviewer,Delete Approver,Effectiveness Check Approver,Effectiveness Check Performer,Evaluator,Extension Approver,Extension Reviewer,Group Report User,Implementation Reviewer,Initiator,Investigator,Obsolete Approver,Obsolete User,Owner,Peer Reviewer,Plan Approver,Planner,Qa,Reopen Approver,Reopen User,Response Reviewer,Reviewer,Revoke Approver,Revoke User,Schedule Approver,Scheduler,Viewer,Assigned On,Assigned By,Active?,Activate/Inactivate Reason";
        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId()
        if (this.managerId) {
          this.whereValsForExcel += " AND USER_ID=" + this.managerId;
        } else if (this.oneQmsUsersFieldData.managerId) {
          this.whereValsForExcel += " AND USER_ID=" + this.oneQmsUsersFieldData.managerId;
        }
        if (this.selectedGroupValueDynamicGridInput != null) {
          this.whereValsForExcel += " AND GROUP_ID=" + this.selectedGroupValueDynamicGridInput + "";
        }
        if (this.qmsservice.adminReportFor == 'QMS User Group') {
          if (this.reportModuleValue != null && this.reportModuleValue != "") {
            console.log("this.reportModuleValue2=", this.reportModuleValue)
            this.whereValsForExcel += " AND MODULE='" + this.reportModuleValue + "'";
          }
        }
      } else if (this.qmsservice.adminReportFor == 'DMS User Group') {
        tname = this.dynamicGridViewName;
        colList = "GROUP_NAME,IS_GROUP_ACTIVE,FOLDER_ID,FOLDER_PATH,CASCASE_TO_CHILD,IS_GROUP_FOLDER_ACTIVE,USER_OR_ROLE,DMS_ROLES,USER_OR_ROLE_ID,USER_OR_ROLE_NAME,IS_USER_OR_ROLE_ACTIVE,FOLDER_ADMINISTRATOR,AUTHOR,REVIEWER,APPROVER,PUBLISHER,QA,TRAINING_COORDINATOR,AUTHORIZER,EXTENSION_REVIEWER,EXTENSION_APPROVER,WITHDRAWAL_REVIEWER,WITHDRAWAL_APPROVER,BLINDED,BLINDBREAK,REDACTOR,DOWNLOADER,VIEWER,CURRENT_VERSION_VIEWER,PRINTER";
        fieldList = "Group Name,Group Active?,Folder ID,Folder Path,Cascase To Child,Group Folder Active?,User Or Role,Dms Roles,User Or Role ID,User Or Role Name,User Or Role Active?,Folder Administrator,Author,Reviewer,Approver,Publisher,Qa,Training Coordinator,Authorizer,Extension Reviewer,Extension Approver,Withdrawal Reviewer,Withdrawal Approver,Blinded,Blindbreak,Redactor,Downloader,Viewer,Current Version Viewer,Print User";
        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId()
        if (this.selectedGroupValueDynamicGridInput != null) {
          this.whereValsForExcel += " AND GROUP_ID=" + this.selectedGroupValueDynamicGridInput + "";
        }
        if (this.qmsservice.adminReportFor == 'DMS User Group') {
          if (this.selectedFolderId != null && this.selectedFolderId != undefined) {
            this.whereValsForExcel += " AND FOLDER_ID=" + this.selectedFolderId + "";
          }
        }
      } else if (this.qmsservice.adminReportFor == 'TMS User Group') {
        tname = this.dynamicGridViewName;
        colList = "GROUP_NAME,IS_GROUP_ACTIVE,VERSION,TRAINING_NAME,TRAINING_CODE,TRAINING_STATUS,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,TRAINING_LEVEL,TRAINING_ASSIGNED_ON,IS_TRAINING_ACTIVE_AT_GROUP,USER_ASSIGNED_ON,USER_NAME,USER_FULLNAME,EMAIL_ADDRESS,IS_USER_ACTIVE,IS_USER_ACTIVE_AT_GROUP,ASSIGNED_ON";
        fieldList = "Group Name,Group Active?,Version,Training Name,Training Code,Training Status,Latest Version?,Latest Published Version?,Training Level,Training Assigned On,Training Active At Group?,User Assigned On,User Name,User Fullname,Email Address,User Active?,User Active At Group?,Assigned On";
        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId()
        if (this.managerId) {
          this.whereValsForExcel += " AND USER_ID=" + this.managerId;
        } else if (this.oneQmsUsersFieldData.managerId) {
          this.whereValsForExcel += " AND USER_ID IN (" + this.oneQmsUsersFieldData.managerId + ")";
        }
        if (this.selectedGroupValueDynamicGridInput != null) {
          this.whereValsForExcel += " AND GROUP_ID=" + this.selectedGroupValueDynamicGridInput + "";
        }
        if (this.qmsservice.adminReportFor == 'TMS User Group') {
          if (this.getSelectedTrainingIdDynamicGridInput != null) {
            this.whereValsForExcel += " AND TRAINING_ID=" + this.getSelectedTrainingIdDynamicGridInput + "";
          }
        }
      } else if (this.qmsservice.adminReportFor == 'Switch User Log') {
        this.whereValsForExcel = "";
        tname = "ONEQMS_SWITCH_USER_LOG_VW";
        colList = "TASK_ID,TASK_DETAILS,SWITCHED_BY_USER,SWITCHED_FROM_USER,SWITCHED_TO_USER,STATUS,SWITCHED_AT,CREATED_ON,MODULE_FULL_NAME,OWNER_NAME,USER_ROLE";
        fieldList = "Task ID,Task Details,Switched By User,Switched From User,Switched To User,Status,Switched At,Created On,Module Name,Owner Name,User Role";
        this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId()
        if (this.selectedReportType == 'qualityIssue' || this.selectedReportType == 'training') {

          this.whereValsForExcel += " AND MODULE='" + this.selectedModuleType + "'";
          if (this.selectedGroupValue) {
            this.whereValsForExcel += " AND GROUP_ID=" + this.selectedGroupValue;
          }
          if (this.getSelectedTaskNo) {
            this.whereValsForExcel += " AND REF_NO=" + this.getSelectedTaskNo;
          }
        } else if (this.selectedReportType == 'DOCS' || this.selectedReportType == 'FORMS') {
          this.whereValsForExcel += " AND MODULE='" + this.selectedReportType + "'";
          if (this.getSelectedTaskNo) {
            this.whereValsForExcel += " AND REF_NO=" + this.getSelectedTaskNo;
          }
        }
      }
      console.log(value, "--------------------");
      const data = {

        wherVal: this.whereValsForExcel == null ? "" : this.whereValsForExcel.toString()
      }
      let tempVals = "";
      if (this.qmsservice.adminReportFor == 'User vs Activity') {
        tempVals = "adminMyPen";
      } else {
        tempVals = "admin";
      }
      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: orderBy,
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: null,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        reModule: tempVals,
        logoId: 0,
        module: "Admin",
        footer: this.selectedReportFooter,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? "Admin Report",
        currentStatus: "NA",
        groupName: "Admin Report",
      }
      this.reportObj = { ...data1, ...data };
      debugger;
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })
        .format(new Date(timestamp))
        .replace(',', '')
        .replaceAll(' ', '_');
      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = `${this.qmsservice.adminReportFor}_${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: "Report", columns: [],
          "informationTab": {
            "Report Name": this.qmsservice.adminReportFor + " Report",
            "Exported By": localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName);
      } else {
        const pdfData = {
          ...this.reportObj, title: this.qmsservice.adminReportFor + "Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName);
      }
    }
  }

  pdfSearchText: string = '';
  openReportPopup(item: any) {
    if (this.qmsservice.adminReportFor == 'Login Failed Attempts') {
      this.columnList = "User Name,User Fullname,Logged Attempted On,Attempt,Is Locked";
    } else if (this.qmsservice.adminReportFor == 'User Login') {
      this.columnList = "User Name,Logged On,Logged Out";
    } else if (this.qmsservice.adminReportFor == 'User Password Changes') {
      this.columnList = "User Name,User Fullname,Password Changed On,Next Password Reset On";
    } else if (this.qmsservice.adminReportFor == 'User vs RM') {
      this.columnList = "User Name,User Full Name,Is AD User,User Description,Designation,Department,Manager Name,Email Address,Contact Number,Country,City,Timezone,Is Active,Created On,Updated On,Created By,Updated By";
    } else if (this.qmsservice.adminReportFor == 'User vs Activity') {
      this.columnList = "Module Code,Version,Task Ref No,Task Name,Sub Task Name,Sub Module Name,Status,Other Details,Task Owner User Name,Requester User Name,Action Requested On,Pending With User Names,Due On";
    } else if (this.qmsservice.adminReportFor == 'User vs Functional Roles Privilege') {
      this.columnList = "User Name,User Fullname,User Active?,Designation,Department,Functional Roles,Application Administrator,User Management,Dashboard Viewer,Topic Administrator,Switch User,Setup Administrator,Audit Trail User,Document Downloader,Document User?,Document User Roles,Root Folder Administrator,Folder Group Administrator,Documents Report User,Document Issuance Tracker,Training User?,Training User Roles,Training Group Administrator,Training Administrator,User Training Administrator,Training QA User,Periodic Reviewer,Instructor Training Administrator,Training Instructor,Instructor Training Approver,Training Report User,Unlock Training User,Quality User?,Quality User Roles,Quality Group Administrator,Change Request User,CAPA User,Deviation User,Audit User,Incident User,Quality Issue User?,Customer Complaint User,CR Roles,CR Report User,CAPA Roles,CAPA Report User,DV Roles,DV Report User,AU Roles,AU Report User,CC Roles,CC Report User,CC Initiator,IN Roles,IN Report User,QI Roles,QI Report User,Training Author Categories,Training Reviewer Approver Categories,Training Owner Categories,Forms And Logs Administrator,Forms And Logs User,Is Bp User,Bp User Roles,Bp Administrator,Bp Report User,Bp Performer,Bp Verifier,Bp Setup Reviewer,Bp Setup Approver,Bp Reviewer,Bp Approver,Update Reason,Updated On,Updated By";
    } else if (this.qmsservice.adminReportFor == 'QMS User Group') {
      this.columnList = "Group Name,Group Description,Group Active?,Module,Group Module Active?,User Active?,User Name,User Fullname,Designation,Department,Qms Roles,Group Module User Active?,Action Approver,Action Deferred Approver,Action Deferred Reviewer,Action Reviewer,Approver,Auditor,Closure Approver,Closure Reviewer,Delete Approver,Effectiveness Check Approver,Effectiveness Check Performer,Evaluator,Extension Approver,Extension Reviewer,Group Report User,Implementation Reviewer,Initiator,Investigator,Obsolete Approver,Obsolete User,Owner,Peer Reviewer,Plan Approver,Planner,Qa,Reopen Approver,Reopen User,Response Reviewer,Reviewer,Revoke Approver,Revoke User,Schedule Approver,Scheduler,Viewer,Assigned On,Assigned By,Active?,Activate/Inactivate Reason";
    } else if (this.qmsservice.adminReportFor == 'DMS User Group') {
      this.columnList = "Group Name,Group Active?,Folder Path,Cascase To Child,Group Folder Active?,User Or Role,Dms Roles,User Or Role Name,User Or Role Active?,Folder Administrator,Author,Reviewer,Approver,Publisher,Qa,Training Coordinator,Authorizer,Extension Reviewer,Extension Approver,Withdrawal Reviewer,Withdrawal Approver,Blinded,Blindbreak,Redactor,Downloader,Viewer,Current Version Viewer,Print User";
    } else if (this.qmsservice.adminReportFor == 'TMS User Group') {
      this.columnList = "Group Name,Group Active?,Version,Training Name,Training Code,Training Status,Latest Version?,Latest Published Version?,Training Level,Training Assigned On,Training Active At Group?,User Assigned On,User Name,User Fullname,Email Address,User Active?,User Active At Group?,Assigned On";
    } else if (this.qmsservice.adminReportFor == 'Switch User Log') {
      this.columnList = "Task ID,Task Details,Switched By User,Switched From User,Switched To User,Status,Switched At,Created On,Module Name,Owner Name,User Role";
    }

    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    this.reportName = "Admin_Report_" + this.qmsservice.adminReportFor
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  //end excell & pdf
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }


}

function formatDateToSQL(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
function subscribe(arg0: (data: any) => void) {
  throw new Error('Function not implemented.');
}

